import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

interface ProtectedRouteProps {
  children: React.ReactNode
  requiredRole?: 'platform_admin' | 'store_owner' | 'customer' | 'store_admin' | 'dispatcher' | 'chef' | 'delivery'
  allowedRoles?: string[]
}

const ProtectedRoute = ({ children, requiredRole, allowedRoles }: ProtectedRouteProps) => {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Verificando acceso...</p>
        </div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  // Si se especifica un rol requerido
  if (requiredRole && user.type !== requiredRole) {
    return <Navigate to="/" replace />
  }

  // Si se especifican roles permitidos
  if (allowedRoles && !allowedRoles.includes(user.type)) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

export default ProtectedRoute

